/**
 * Indicates whether single sided quotes are allowed.
 * tag: 2559
 * @readonly
 * @enum {string} (Boolean)
 */
export enum QuoteSideIndicator {
  No = 'N',
  Yes = 'Y',
}
